import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type UpdateTeamMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.UpdateTeamInput>;
}>;


export type UpdateTeamMutation = { __typename?: 'Mutation', updateTeam: { __typename: 'UpdateTeamSuccessPayload' } };

export type SettingsPageTeamManagementDetailViewQueryVariables = Types.Exact<{
  guid: Types.Scalars['ID']['input'];
}>;


export type SettingsPageTeamManagementDetailViewQuery = { __typename?: 'Query', team: { __typename?: 'Team', guid: string, name: string, staffs: Array<{ __typename?: 'Staff', guid: string, name?: string | null, displayName: string }> } };

export type AddStaffToTeamModalQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AddStaffToTeamModalQuery = { __typename?: 'Query', staffsByPlanner: Array<{ __typename?: 'Staff', guid: string, displayName: string }> };


export const UpdateTeamDocument = gql`
    mutation updateTeam($input: UpdateTeamInput) {
  updateTeam(input: $input) {
    __typename
  }
}
    `;

/**
 * __useUpdateTeamMutation__
 *
 * To run a mutation, you first call `useUpdateTeamMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateTeamMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTeamMutation(options: VueApolloComposable.UseMutationOptions<UpdateTeamMutation, UpdateTeamMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateTeamMutation, UpdateTeamMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateTeamMutation, UpdateTeamMutationVariables>(UpdateTeamDocument, options);
}
export type UpdateTeamMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateTeamMutation, UpdateTeamMutationVariables>;
export const SettingsPageTeamManagementDetailViewDocument = gql`
    query SettingsPageTeamManagementDetailView($guid: ID!) {
  team(guid: $guid) {
    guid
    name
    staffs {
      guid
      name
      displayName
    }
  }
}
    `;

/**
 * __useSettingsPageTeamManagementDetailViewQuery__
 *
 * To run a query within a Vue component, call `useSettingsPageTeamManagementDetailViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingsPageTeamManagementDetailViewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSettingsPageTeamManagementDetailViewQuery({
 *   guid: // value for 'guid'
 * });
 */
export function useSettingsPageTeamManagementDetailViewQuery(variables: SettingsPageTeamManagementDetailViewQueryVariables | VueCompositionApi.Ref<SettingsPageTeamManagementDetailViewQueryVariables> | ReactiveFunction<SettingsPageTeamManagementDetailViewQueryVariables>, options: VueApolloComposable.UseQueryOptions<SettingsPageTeamManagementDetailViewQuery, SettingsPageTeamManagementDetailViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SettingsPageTeamManagementDetailViewQuery, SettingsPageTeamManagementDetailViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SettingsPageTeamManagementDetailViewQuery, SettingsPageTeamManagementDetailViewQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SettingsPageTeamManagementDetailViewQuery, SettingsPageTeamManagementDetailViewQueryVariables>(SettingsPageTeamManagementDetailViewDocument, variables, options);
}
export function useSettingsPageTeamManagementDetailViewLazyQuery(variables?: SettingsPageTeamManagementDetailViewQueryVariables | VueCompositionApi.Ref<SettingsPageTeamManagementDetailViewQueryVariables> | ReactiveFunction<SettingsPageTeamManagementDetailViewQueryVariables>, options: VueApolloComposable.UseQueryOptions<SettingsPageTeamManagementDetailViewQuery, SettingsPageTeamManagementDetailViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SettingsPageTeamManagementDetailViewQuery, SettingsPageTeamManagementDetailViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SettingsPageTeamManagementDetailViewQuery, SettingsPageTeamManagementDetailViewQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SettingsPageTeamManagementDetailViewQuery, SettingsPageTeamManagementDetailViewQueryVariables>(SettingsPageTeamManagementDetailViewDocument, variables, options);
}
export type SettingsPageTeamManagementDetailViewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SettingsPageTeamManagementDetailViewQuery, SettingsPageTeamManagementDetailViewQueryVariables>;
export const AddStaffToTeamModalDocument = gql`
    query AddStaffToTeamModal {
  staffsByPlanner {
    guid
    displayName
  }
}
    `;

/**
 * __useAddStaffToTeamModalQuery__
 *
 * To run a query within a Vue component, call `useAddStaffToTeamModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddStaffToTeamModalQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAddStaffToTeamModalQuery();
 */
export function useAddStaffToTeamModalQuery(options: VueApolloComposable.UseQueryOptions<AddStaffToTeamModalQuery, AddStaffToTeamModalQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AddStaffToTeamModalQuery, AddStaffToTeamModalQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AddStaffToTeamModalQuery, AddStaffToTeamModalQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AddStaffToTeamModalQuery, AddStaffToTeamModalQueryVariables>(AddStaffToTeamModalDocument, {}, options);
}
export function useAddStaffToTeamModalLazyQuery(options: VueApolloComposable.UseQueryOptions<AddStaffToTeamModalQuery, AddStaffToTeamModalQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AddStaffToTeamModalQuery, AddStaffToTeamModalQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AddStaffToTeamModalQuery, AddStaffToTeamModalQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AddStaffToTeamModalQuery, AddStaffToTeamModalQueryVariables>(AddStaffToTeamModalDocument, {}, options);
}
export type AddStaffToTeamModalQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AddStaffToTeamModalQuery, AddStaffToTeamModalQueryVariables>;